import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./holiday.css";

export default function AddHoliday() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [form,   setForm]   = useState({ title:"", start_date:"", end_date:"", description:"" });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.start_date || !form.end_date)
      return alert("Title, start date and end date are required");
    if (form.end_date < form.start_date)
      return alert("End date cannot be before start date");
    try {
      setSaving(true);
      await API.post(
        "/school-admin/holidays/add/",
        { title: form.title.trim(), start_date: form.start_date, end_date: form.end_date, description: form.description.trim() },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      navigate("/school-admin/holidays");
    } catch (err) { console.error(err); alert("Failed to add holiday"); }
    finally { setSaving(false); }
  };

  return (
    <div className="hl-page">

      {/* ══ HERO ══ */}
      <div className="hl-hero">
        <div className="hl-hero-left">
          <div className="hl-hero-icon">🎉</div>
          <div>
            <h2 className="hl-hero-title">Add Holiday</h2>
            <p className="hl-hero-sub">Schedule a new school holiday</p>
          </div>
        </div>
        <div className="hl-hero-right">
          <button className="hl-btn-back" onClick={() => navigate("/school-admin/holidays")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={submit}>
        <div className="hl-form-card">
          <p className="hl-form-title">Holiday Details</p>

          <div className="hl-grid-3">
            <div className="hl-field" style={{ gridColumn:"1/-1" }}>
              <label>Holiday Title *</label>
              <input
                required
                placeholder="e.g. Diwali, Summer Vacation, Christmas"
                value={form.title}
                onChange={e => set("title", e.target.value)}
              />
            </div>
            <div className="hl-field">
              <label>Start Date *</label>
              <input type="date" required value={form.start_date} onChange={e => set("start_date", e.target.value)} />
            </div>
            <div className="hl-field">
              <label>End Date *</label>
              <input type="date" required value={form.end_date} onChange={e => set("end_date", e.target.value)} />
            </div>
            <div className="hl-field">
              <label>Duration</label>
              <input
                readOnly
                style={{ background:"#f0fdfa", color:"#0f766e", fontWeight:700, cursor:"default" }}
                value={
                  form.start_date && form.end_date && form.end_date >= form.start_date
                    ? `${Math.max(1, Math.round((new Date(form.end_date) - new Date(form.start_date)) / 86400000) + 1)} day(s)`
                    : "—"
                }
              />
            </div>
          </div>

          <div className="hl-grid-1">
            <div className="hl-field">
              <label>Description (optional)</label>
              <textarea
                placeholder="Optional note for parents / teachers…"
                value={form.description}
                onChange={e => set("description", e.target.value)}
              />
            </div>
          </div>
        </div>

        <button type="submit" className="hl-btn-submit" disabled={saving}>
          {saving ? <><div className="hl-spinner"></div> Saving…</> : "🎉 Add Holiday"}
        </button>
      </form>

    </div>
  );
}
